import { appInfoForUiGuideSteps } from 'console/ui-guide/steps/index';
import { removeNulls } from 'utils';
const addAppInfoToStep = (group_id, steps) => {
    const app_info_steps = appInfoForUiGuideSteps[group_id];
    return removeNulls(steps.map((step) => {
        const app_info = app_info_steps[step.id];
        if (!app_info) {
            return null;
        }
        return {
            ...app_info,
            id: step.id,
            content: step.text,
            forward_callbacks: app_info?.forward_callbacks ?? [],
            back_callbacks: app_info?.back_callbacks ?? [],
            placement: app_info?.placement ?? 'auto',
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
        };
    }));
};
export const addAppInfoToUiGuideGroups = (groups) => groups.map((group) => ({
    id: group.id,
    steps: addAppInfoToStep(group.id, group.steps),
}));
